import React from "react";
import { 
  BookSelectionContainer,
  BookLabel,
  BookSelect
} from "../Returns.styled";
import { LoadingIndicator } from "../../../components/LoadingIndicator/LoadingIndicator";
import { IAuction } from "../../../services";
import { BookService } from "../../../services";

interface BookSelectionProps {
  book: { bookCode: string; bookName: string };
  auction: IAuction | undefined;
  onBookSelectionChanged: (book: { bookCode: string; bookName: string }) => void;
  isLoading: boolean;
}

/**
 * Component for selecting a book from dropdown
 */
export const BookSelection: React.FC<BookSelectionProps> = ({
  book,
  auction,
  onBookSelectionChanged,
  isLoading
}) => {
  const bookService = new BookService();
  const books = bookService.getBooksFromAuction(auction ? auction : ({} as IAuction));

  return (
    <BookSelectionContainer>
      <BookLabel htmlFor="book-select">Book</BookLabel>
      <BookSelect
        id="book-select"
        value={book.bookCode}
        onChange={(e) => {
          const selectedBook = books.find(b => b.key === e.target.value);
          onBookSelectionChanged({ 
            bookCode: e.target.value, 
            bookName: selectedBook ? selectedBook.value : e.target.value 
          });
        }}
        disabled={false}
      >
        {bookService
          .getBooksFromAuction(auction ? auction : ({} as IAuction))
          .map((bookItem) => (
            <option key={bookItem.key} value={bookItem.key}>
              {bookItem.value}
            </option>
          ))}
      </BookSelect>
      {isLoading && <LoadingIndicator />}
    </BookSelectionContainer>
  );
};